const heyLightStyles = [
  "font-family: 'HeyLight Sans', sans-serif",
  'font-size: 16px',
  'font-weight: 400',
  'line-height: 1.5',
];

export const wrapDisplayData = (string: string) =>
  `<body style="${heyLightStyles.join(';')}">${string}</body>`;
